import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getItem,
  getItemById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  createItem,
  updateItem,
} from "./thunk";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  items: [],
  item: null,
  productAdditionalDetailsProduct: null,
  productCosting: null,
  termConditionForInvoice: null,
  edit: false,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingCreate: false,
  loadingItem: false,
  loadingNext: false,
  standardCostRate: [
    {
      unique: uuidv4(),
      applicableFrom: null,
      rate: 0,
    },
  ],
  standardSellingPrice: [
    {
      unique: uuidv4(),
      applicableFrom: null,
      rate: 0,
    },
  ],
  standardTradeRate: [
    {
      unique: uuidv4(),
      applicableFrom: null,
      rate: 0,
    },
  ],
  standardMRP: [
    {
      unique: uuidv4(),
      applicableFrom: null,
      rate: 0,
    },
  ],
  preferedSupplier: [
    {
      unique: uuidv4(),
      supplier: null,
    },
  ],
  showCreateModal: false,
};

export const itemSlice = createSlice({
  name: "item",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    editItem: (state) => {
      state.edit = true;
      state.loading = false;
    },
    standardCostRateUpdate: (state, action) => {
      state.standardCostRate = action.payload;
    },
    standardSellingPriceUpdate: (state, action) => {
      state.standardSellingPrice = action.payload;
    },
    standardTradeRateUpdate: (state, action) => {
      state.standardTradeRate = action.payload;
    },
    standardMRPUpdate: (state, action) => {
      state.standardMRP = action.payload;
    },
    preferedSupplierUpdate: (state, action) => {
      state.preferedSupplier = action.payload;
    },
    clearAllItem: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingItem = false;
      state.item = null;
      state.standardCostRate = [
        {
          unique: uuidv4(),
          applicableFrom: null,
          rate: 0,
        },
      ];
      state.standardSellingPrice = [
        {
          unique: uuidv4(),
          applicableFrom: null,
          rate: 0,
        },
      ];
      state.standardTradeRate = [
        {
          unique: uuidv4(),
          applicableFrom: null,
          rate: 0,
        },
      ];
      state.standardMRP = [
        {
          unique: uuidv4(),
          applicableFrom: null,
          rate: 0,
        },
      ];
      state.preferedSupplier = [
        {
          unique: uuidv4(),
          supplier: null,
        },
      ];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getItemById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getItemById.fulfilled, (state, action) => {
      state.loading = false;
      state.item = action.payload;
      state.productAdditionalDetailsProduct = action.payload.productAdditionalDetailsProduct;
      state.productCosting = action.payload.productCosting;
      state.termConditionForInvoice = action.payload.termConditionForInvoice;
    });
    builder.addCase(getItemById.rejected, (state) => {
      state.loading = false;
    });

    builder.addMatcher(isAnyOf(updateItem.pending, createItem.pending), (state) => {
      state.loadingCreate = true;
    });
    builder.addMatcher(isAnyOf(updateItem.fulfilled, createItem.fulfilled), (state) => {
      state.loadingCreate = false;
    });
    builder.addMatcher(isAnyOf(updateItem.rejected, createItem.rejected), (state) => {
      state.loadingCreate = false;
    });

    builder.addMatcher(
      isAnyOf(getItem.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingItem = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getItem.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingItem = false;
        state.items = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getItem.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingItem = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  editItem,
  standardCostRateUpdate,
  standardSellingPriceUpdate,
  standardTradeRateUpdate,
  standardMRPUpdate,
  preferedSupplierUpdate,
  clearAllItem,
} = itemSlice.actions;

export default itemSlice.reducer;
